import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Widget from '../components/Widget';
import SubWidget from '../components/SubWidget';
import ConsultingChessBoard from '../components/ConsultingChessBoard';
import ChessWebServices from '../components/ChessWebServices';
import TwitterWidget from '../components/TweetEmbed';
import VideoWidget from '../components/VideoCard';
import ImageWidget from '../components/ImageGallery';
import IndieDefinition from '../components/IndieDefinition';
import SeeMoreWidget from '../components/SeeMoreWidget';
import FeaturedWidget from '../components/FeaturedWidget';
import DirectoryHeader from '../components/DirectoryHeader';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChessBoard } from '@fortawesome/free-solid-svg-icons';
import { getPublishedBlogs } from '../services/blogService';
import { getWidgets } from '../services/widgetService';


const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const PINNED_WIDGETS = {
  people: 'Charlize van Zyl',
  openings: 'Opening Tree',
  analysis: 'Chessiro',
  play: 'Lichess',
  learn: 'ChessMood',
  pros: '2700Chess',
  books: 'Forward Chess'
};

const HomePage = () => {
  const [selectedFilter, setSelectedFilter] = React.useState('home');
  const [selectedSubFilter, setSelectedSubFilter] = React.useState(null);
  const [selectedDeviceFilter, setSelectedDeviceFilter] = React.useState(null);
  const [isSearchMode, setIsSearchMode] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [tabAlphabeticalState, setTabAlphabeticalState] = React.useState({
    indie: false,
    all: false,
    chess: false,
    device: false,
    events: false,
    people: false
  });
  const [recentBlogs, setRecentBlogs] = React.useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [widgetData, setWidgetData] = useState([]);
  const [shuffledWidgetData, setShuffledWidgetData] = useState([]);
  const [recentUpdatesData, setRecentUpdatesData] = useState([]);
  const [hasInitialized, setHasInitialized] = useState(false); // Initialization of widgetData
  const [showWhatIsThis, setShowWhatIsThis] = useState(false);

  // Fetch widgets from Firestore
  useEffect(() => {
    const fetchWidgets = async () => {
      try {
        setLoading(true);
        setError(null);

        const widgets = await getWidgets();
        setWidgetData(widgets);
        setShuffledWidgetData(shuffleArray(widgets));
      } catch (error) {
        console.error('Error fetching widgets:', error);
        setError('Failed to load widgets');
      } finally {
        setLoading(false);
      }
    };

    fetchWidgets();
  }, []);

  // Handle blog navigation
  useEffect(() => {
    if (selectedFilter === 'blog') {
      navigate('/blogs');
    }
  }, [selectedFilter, navigate]);

  // Fetch recent blog posts for blog row
  useEffect(() => {
    const fetchRecentBlogs = async () => {
      try {
        const blogs = await getPublishedBlogs();
        if (blogs && blogs.length > 0) {
          setRecentBlogs(blogs);
        }
      } catch (error) {
        console.error('Failed to fetch recent blogs:', error);
      }
    };

    fetchRecentBlogs();
  }, []);

  // Function to truncate text
  const truncateText = (text, maxLength = 25) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  // Function to scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  // filters array moved to DirectoryHeader component

// Widget data array with all widgets including hidden ones
// const widgetData = [
//   // Sample data, customize as needed
//   {
//     title: "FIDE",
//     subtitle: "international chess federation",
//     icon: "/images/FIDE.png",
//     link: "https://fide.com",
//     indie: false,
//     hidden: false,
//     tag: "other",
//     devices: ['web']
//   },
//   {
//     title: "Lichess",
//     subtitle: "play chess free",
//     icon: "/images/LiChess.png",
//     link: "https://lichess.org",
//     indie: true,
//     hidden: false,
//     tag: "play",
//     verified: true,
//     devices: ['web', 'ios', 'android'],
//     links: {}
//   },
//   {
//     title: "ChessThread",
//     subtitle: "create chess content",
//     icon: "/images/ChessThread.png",
//     link: "https://chessthread.com",
//     indie: true,
//     hidden: false,
//     tag: "social",
//     verified: true,
//     devices: ['web']
//   },
//   {
//     title: "Chessvision.ai",
//     subtitle: "scan any position",
//     icon: "/images/ChessVision.png",
//     link: "https://chessvision.ai",
//     indie: false,
//     hidden: false,
//     tag: "learn",
//     devices: ['web', 'ios', 'android']
//   },
//   {
//     title: "KillerChessTraining",
//     subtitle: "chess training",
//     icon: "/images/KillerChessTraining.png",
//     link: "https://killerchesstraining.com/",
//     indie: true,
//     hidden: false,
//     tag: "learn",
//     verified: true,
//     devices: ['web']
//   },
//   {
//     title: "ChessBase India",
//     subtitle: "global media coverage",
//     icon: "/images/ChessbaseIndia.png",
//     link: "https://chessbase.in",
//     indie: false,
//     hidden: false,
//     tag: "professionals",
//     devices: ['web', 'android'],
//     links: {
//       website: "https://chessbase.in",
//       instagram: "https://www.instagram.com/chessbaseindia/",
//       twitter: "https://x.com/ChessbaseIndia",
//       facebook: "https://www.facebook.com/chessbaseindia",
//       youtube: "https://www.youtube.com/@ChessBaseIndiachannel"
//     }
//   },
//   {
//     title: "Chessdom",
//     subtitle: "chess news outlet",
//     icon: "/images/Chessdom.png",
//     link: "https://www.chessdom.com",
//     indie: false,
//     hidden: false,
//     tag: "professionals",
//     verified: true,
//     devices: ['web'],
//     links: {
//       website: "https://www.chessdom.com",
//       facebook: "https://www.facebook.com/chessdom/",
//       twitter: "https://x.com/chessdom"
//     }
//   },
//   {
//     title: "2700Chess",
//     subtitle: "professional rankings",
//     icon: "/images/2700.png",
//     link: "https://2700chess.com",
//     indie: false,
//     hidden: false,
//     tag: "professionals"
//   },
//   {
//     title: "Chess.com",
//     subtitle: "play chess",
//     icon: "/images/Chesscom.png",
//     link: "https://chess.com",
//     indie: false,
//     hidden: false,
//     tag: "play",
//     devices: ['web', 'ios', 'android'],
//     links: {}
//   },
//   {
//     title: "Oakmate",
//     subtitle: "free game review",
//     icon: "/images/Oakmate.png",
//     link: "https://oakmate.app",
//     indie: true,
//     hidden: false,
//     tag: "analysis",
//     verified: true,
//     devices: ['web']
//   },
//   {
//     title: "ChessPuzzle.net",
//     subtitle: "tactical training",
//     icon: "/images/ChessPuzzleNet.png",
//     link: "https://chesspuzzle.net",
//     indie: true,
//     hidden: false,
//     tag: "learn",
//     devices: ['web'],
//     links: {
//       website: "https://chesspuzzle.net"
//     }
//   },
//   {
//     title: "Opening Tree",
//     subtitle: "opening explorer",
//     icon: "/images/OpeningTree.png",
//     link: "https://www.openingtree.com/",
//     indie: true,
//     hidden: false,
//     tag: "openings",
//     devices: ['web']
//   },
//   {
//     title: "Chessiverse",
//     subtitle: "play vs bots",
//     icon: "/images/Chessiverse.png",
//     link: "https://chessiverse.com",
//     indie: true,
//     hidden: false,
//     tag: "play",
//     devices: ['web']
//   },
//   {
//     title: "SmallChess",
//     subtitle: "ai chess analysis",
//     icon: "/images/Smallfish.png",
//     link: "https://smallchess.com",
//     indie: true,
//     hidden: false,
//     tag: "analysis",
//     verified: true
//   },
//   // ... (the rest of the widgetData, as per the latest pulled changes, continue adding more widgets)
// ];

  // Recent Updates Data - Featured widgets that appear only at the top of home page
  const recentUpdatesStatic = [
    // ROW 1: BIG | small/small column | BIG | small/small column
    {
      title: "TrendingChess Blog",
      subtitle: "chess insights & stories",
      icon: "/images/IndieChessBlog.png",
      link: "/blogs",
      isUpdate: true,
      hidden: false,
      size: "double",
      row: 1
    },
    {
      title: "KillerChessTraining",
      subtitle: "chess training",
      icon: "/images/KillerChessTraining.png",
      link: "https://killerchesstraining.com/",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "top"
    },
    {
      title: "New in Chess",
      subtitle: "chess magazine",
      icon: "/images/NewInChess.png",
      link: "https://www.newinchess.com",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "top"
    },
    {
      title: "TheChessArchives",
      subtitle: "memories on instagram",
      icon: "/images/TheChessArchives.png",
      link: "https://www.instagram.com/thechessarchives/",
      isUpdate: true,
      hidden: false,
      size: "double",
      row: 1
    },
    {
      title: "ChessFlare",
      subtitle: "chess platform",
      icon: "/images/ChessFlare.png",
      link: "https://chessflare.com/",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "top"
    },
    {
      title: "Submit Listing",
      subtitle: "add your app or project",
      icon: "/images/SubmitListing.png",
      link: "/submit",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "top"
    },
    // ROW 2: Small widgets below the big ones
    // {
    //   title: "IndieChess",
    //   subtitle: "indie chess",
    //   icon: "/images/IndieChess.png",
    //   link: "/IndieChess",
    //   isUpdate: true,
    //   hidden: false,
    //   size: "normal",
    //   isNew: false,
    //   row: 1,
    //   subRow: "bottom"
    // },
    {
      title: "Charlize",
      subtitle: "chess creator",
      icon: "/images/Charlize.png",
      link: "https://www.instagram.com/charlizevz/",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "bottom"
    },
    {
      title: "FOMO Chess",
      subtitle: "chess platform",
      icon: "/images/FomoChess.png",
      link: "https://play.google.com/store/apps/details?id=com.fomochess.app",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "bottom"
    },
    {
      title: "Grandmaster Daniel King",
      subtitle: "PowerPlayChess creator",
      icon: "/images/DanielKing.png",
      link: "https://www.youtube.com/@PowerPlayChess",
      isUpdate: true,
      hidden: false,
      size: "normal",
      isNew: false,
      row: 1,
      subRow: "bottom"
    },
    
  ];

  // Data for widgets that are not stored in FireStore
  const noWidgetData = [{
    title: "TrendingChess",
    subtitle: "trending chess",
    icon: "/images/IndieChessMe.png",
    link: "https://twitter.com/TrendingChess",
    isNew: false,
    size: "normal"
  },
  {
    title: "Submit Listing",
    subtitle: "add your app or project",
    icon: "/images/SubmitListing.png",
    link: "/submit",
    isNew: false,
    size: "normal"
  }];

  // Recent Updates Data - Featured widgets that appear only at the top of home page
  const recentUpdates = ["ChessBase India", "IndieChess", "Chessvision.ai", "ChessEver", "Submit Listing", "FIDE Candidates 2026", "Charlize van Zyl", "Lichess"];

  // Parse date from DDMMYY format to comparable value
  const parseDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 6) return 0;
    const day = parseInt(dateStr.substring(0, 2));
    const month = parseInt(dateStr.substring(2, 4));
    const year = parseInt(dateStr.substring(4, 6));
    // Convert to YYMMDD for proper sorting
    return year * 10000 + month * 100 + day;
  };

  // Get featured widgets for Recent Chess Updates section
  const getFeaturedWidgets = (widgets) => {
    if (!Array.isArray(widgets)) return [];
    const recentUpdatesData = [];

    for (const recentUpdate of recentUpdates) {
      const match = widgets.find(w => w.title === recentUpdate);
      if (match) {
        recentUpdatesData.push(match);
      }
    }

    return recentUpdatesData.map(item => {
      if (item.widgetRef) {
        // Find and return existing widget with size info
        const existingWidget = widgets.find(w => w.title === item.widgetRef);
        if (existingWidget) {
          return { ...existingWidget, size: item.size || 'normal' };
        }
      }
      // Return custom update widget (only shows in featured section)
      return item;
    }).filter(Boolean); // Remove any null entries
  };

  useEffect(() => {
    // Only run this after widgetData is fetched and not empty
    // And only once
    if (hasInitialized || widgetData.length === 0) return;

    // Combine the database widgets with static ones
    const combinedWidgets = [...widgetData, ...noWidgetData];

    // Get featured widgets based on recentUpdates list
    const featured = getFeaturedWidgets(combinedWidgets);

    // Set the combined widget data (if needed)
    setWidgetData(combinedWidgets);
    setShuffledWidgetData(shuffleArray(combinedWidgets));

    // Set featured widgets
    setRecentUpdatesData(featured);

    // Mark that this initialization has run
    setHasInitialized(true);
  }, [widgetData, hasInitialized]);

  // Get widgets for home page categories with deduplication
  const getHomePageWidgets = () => {
    const categories = [
      { name: 'people', filter: w => Array.isArray(w.tag) ? (w.tag.includes('people') || w.tag.includes('creators') || w.tag.includes('professionals')) : (w.tag === 'people' || w.tag === 'creators' || w.tag === 'professionals') },
      { name: 'openings', filter: w => Array.isArray(w.tag) ? w.tag.includes('openings') : w.tag === 'openings' },
      { name: 'analysis', filter: w => Array.isArray(w.tag) ? w.tag.includes('analysis') : w.tag === 'analysis' },
      { name: 'play', filter: w => Array.isArray(w.tag) ? w.tag.includes('play') : w.tag === 'play' },
      { name: 'learn', filter: w => Array.isArray(w.tag) ? w.tag.includes('learn') : w.tag === 'learn' },
      { name: 'books', filter: w => Array.isArray(w.tag) ? w.tag.includes('books') : w.tag === 'books' }
    ];

    const visibleWidgets = shuffledWidgetData.filter(w => !w.hidden && !w.isUpdate && w.title !== "Add Listing");
    const homeCategories = [];

    categories.forEach(category => {
      const categoryWidgets = visibleWidgets
        .filter(w => category.filter(w));

      if (categoryWidgets.length > 0) {
        const pinnedTitle = PINNED_WIDGETS[category.name];
        const pinned = pinnedTitle ? categoryWidgets.find(w => w.title === pinnedTitle) : null;
        const rest = pinned ? categoryWidgets.filter(w => w.title !== pinnedTitle) : categoryWidgets;
        const ordered = pinned ? [pinned, ...rest] : categoryWidgets;

        homeCategories.push({
          name: category.name,
          widgets: ordered.slice(0, 6)
        });
      }
    });

    return homeCategories;
  };

  // Filter blogs by search query
  const getSearchedBlogs = () => {
    if (!isSearchMode || !searchQuery) return [];
    const q = searchQuery.toLowerCase();
    return recentBlogs.filter(b => b.title && b.title.toLowerCase().includes(q));
  };

  // Filter and sort widgets based on selected filter or search query
  const getFilteredWidgets = () => {
    // First, filter out hidden widgets and update-only widgets
    let visibleWidgets = shuffledWidgetData.filter(w => !w.hidden && !w.isUpdate);
    let filteredWidgets = [];
    
    // If in search mode, filter by search query
    if (isSearchMode && searchQuery) {
      const query = searchQuery.toLowerCase();
      filteredWidgets = visibleWidgets.filter(w => 
        (w.title && w.title.toLowerCase().includes(query)) ||
        (w.subtitle && w.subtitle.toLowerCase().includes(query))
      );
    }
    // If in search mode but no query, show all widgets
    else if (isSearchMode) {
      filteredWidgets = visibleWidgets;
    }
    // Apply device filter if selected
    else if (selectedFilter === 'device' && selectedDeviceFilter) {
      filteredWidgets = visibleWidgets.filter(w => 
        w.devices && w.devices.includes(selectedDeviceFilter)
      );
    }
    // Apply chess sub-filter if selected
    else if (selectedFilter === 'chess' && selectedSubFilter) {
      // Handle 'mafia' special case
      if (selectedSubFilter === 'mafia') {
        return [];
      }
      // Handle special cases - filter by isNew or indie instead of tag
      if (selectedSubFilter === 'new') {
        filteredWidgets = visibleWidgets.filter(w => w.isNew);
      } else {
        filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? w.tag.includes(selectedSubFilter) : w.tag === selectedSubFilter);
      }
    }
    // Otherwise use normal filter logic
    else {
      switch(selectedFilter) {
        case 'chess':
          // Show all widgets when chess tab is clicked without sub-filter selection
          // Actual filtering happens above when sub-filter is selected
          filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? !(w.tag.includes('people') || w.tag.includes('creators') || w.tag.includes('professionals')) : !['people', 'creators', 'professionals'].includes(w.tag));
          break;

        case 'device':
          // Show all widgets when device tab is clicked without sub-filter selection
          // Actual filtering happens above when device sub-filter is selected
          filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? !(w.tag.includes('people') || w.tag.includes('creators') || w.tag.includes('professionals')) : !['people', 'creators', 'professionals'].includes(w.tag));
          break;

        case 'events':
          filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? w.tag.includes('events') : w.tag === 'events');
          break;

        case 'blog':
          return []; // Will be handled by useEffect

        case 'people':
          filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? (w.tag.includes('people') || w.tag.includes('creators') || w.tag.includes('professionals')) : ['people', 'creators', 'professionals'].includes(w.tag));
          break;
          
        case 'books':
          filteredWidgets = visibleWidgets.filter(w => Array.isArray(w.tag) ? w.tag.includes('books') : w.tag === 'books');
          break;
          
        case 'contact':
          return []; // Empty - navigation handled in onClick

        case 'home':
          return []; // Home page uses different layout
          
        default: // 'all'
          filteredWidgets = visibleWidgets.filter(w => !w.excludeFromAll); // Show all content types except those with excludeFromAll
          break;
      }
    }

    // Apply alphabetical sorting if toggle is active for current tab
    if (tabAlphabeticalState[selectedFilter] || (isSearchMode && tabAlphabeticalState[selectedFilter])) {
      filteredWidgets = filteredWidgets.sort((a, b) =>
        (a.title || '').localeCompare(b.title || '')
      );
    } else {
      // Pin featured widget first (data is already shuffled from load)
      const pinnedTitle = PINNED_WIDGETS[selectedFilter] || (selectedSubFilter && PINNED_WIDGETS[selectedSubFilter]);
      const pinned = pinnedTitle ? filteredWidgets.find(w => w.title === pinnedTitle) : null;
      if (pinned) {
        const rest = filteredWidgets.filter(w => w.title !== pinnedTitle);
        filteredWidgets = [pinned, ...rest];
      }
    }

    return filteredWidgets;
  };

  const miniWidgets = [
    { title: 'SETTINGS', icon: '⚙️', onClick: () => console.log('') },
    { title: 'MORE', icon: '⋯', onClick: () => console.log('') },
    { title: 'WIDGETS', icon: '🧩', onClick: () => console.log('') },
    { title: '+1', icon: '➕', onClick: () => console.log('') }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="max-w-6xl mx-auto px-4"
    >
     


      {/* Chess Chat Interface */}
      {/* <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="max-w-2xl mx-auto mb-12"
      >
        <div className="relative flex items-center gap-3">
          <button
            onClick={() => console.log('Board editor clicked')}
            className="bg-gray-800 border border-gray-600 rounded-xl p-4 text-gray-400 hover:text-gray-300 hover:border-gray-500 transition-all duration-200"
          >
            <FontAwesomeIcon icon={faChessBoard} className="text-xl" />
          </button>
          
          <div className="flex-1 relative">
            <input
              type="text"
              value={chatQuery}
              onChange={(e) => setChatQuery(e.target.value)}
              placeholder="Ask anything about chess..."
              className="w-full bg-gray-800 border border-gray-600 rounded-full pl-6 pr-14 py-4 text-gray-100 placeholder-gray-400 focus:outline-none focus:border-gray-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 text-lg"
            />
            <button
              onClick={() => console.log('Send chat:', chatQuery)}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-blue-600 hover:bg-blue-500 rounded-full p-2 text-white transition-all duration-200"
            >
              <FontAwesomeIcon icon={faPaperPlane} className="text-sm" />
            </button>
          </div>
        </div>
      </motion.div> */}

      {/* Directory Header */}
      <DirectoryHeader
        activeCategory={selectedFilter !== 'home' ? (selectedSubFilter || selectedFilter) : null}
        activeSubFilter={selectedSubFilter}
        onFilterChange={(filterId, subFilterId) => {
          setShowWhatIsThis(false);
          if (filterId === 'home') {
            setSelectedFilter('home');
            setSelectedSubFilter(null);
            setSelectedDeviceFilter(null);
          } else if (subFilterId) {
            setSelectedFilter(filterId);
            setSelectedSubFilter(subFilterId);
            setSelectedDeviceFilter(null);
          } else {
            setSelectedFilter(filterId);
            setSelectedSubFilter(null);
            setSelectedDeviceFilter(null);
          }
        }}
        onSearchChange={(query) => {
          if (query) {
            setIsSearchMode(true);
            setSearchQuery(query);
          } else {
            setIsSearchMode(false);
            setSearchQuery('');
          }
        }}
        tabAlphabeticalState={tabAlphabeticalState}
        onToggleAlphabetical={(filterId) => {
          setTabAlphabeticalState(prev => ({
            ...prev,
            [filterId]: !prev[filterId]
          }));
        }}
      />

      {/* Widget Grid - iPhone App Style */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className={selectedFilter === 'home' && !isSearchMode ? "pt-32" : "grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4 md:gap-4 lg:gap-4 pt-32"}
      >
        {selectedFilter === 'home' && !isSearchMode && showWhatIsThis ? (
          <div className="max-w-3xl mx-auto px-4 py-8">
            <button
              onClick={() => setShowWhatIsThis(false)}
              className="mb-8 text-gray-400 hover:text-gray-200 transition-colors flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faChessBoard} className="text-sm" />
              Back to Directory
            </button>
            <div className="flex items-center gap-4 mb-6">
              <img src="/images/WhatIsThis.png" alt="What is Trending Chess?" className="w-20 h-20 rounded-2xl" />
              <div>
                <h1 className="text-3xl font-bold text-gray-100">What is Trending Chess?</h1>
              </div>
            </div>
            <div className="prose prose-invert max-w-none space-y-4">
              <p className="text-gray-300 leading-relaxed"><strong className="text-gray-100">TrendingChess.com</strong> is a directory of the chess world: apps, people, tools, events, and more, all in one place. Every listing gets its own page, kept up to date with the help of AI.</p>
              <h3 className="text-xl font-semibold text-gray-100 mt-6">What You'll Find Here</h3>
              <p className="text-gray-300 leading-relaxed">Chess platforms, coaching tools, players, streamers, coaches, events, academies, books: if it's part of the chess world online, it's probably here. And if it's not, you can <a href="/submit" className="text-yellow-400 hover:text-yellow-300">submit a listing</a>.</p>
              <h3 className="text-xl font-semibold text-gray-100 mt-6">Built With AI, Run By a Human</h3>
              <p className="text-gray-300 leading-relaxed">AI helps us discover, research, and write about chess entities at a scale one person never could alone. But there's a real person behind it all — reviewing, curating, and making sure things actually make sense. We're open about using AI because we think transparency makes the internet better.</p>
              <h3 className="text-xl font-semibold text-gray-100 mt-6">Who's Behind This?</h3>
              <p className="text-gray-300 leading-relaxed">Christopher P. (<a href="https://indiechess.com" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300">@IndieChess</a>), a solo founder building tools for the chess community. TrendingChess is part of the Indie Chess ecosystem, alongside <a href="https://chessweb.site" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300">ChessWeb.site</a>, a website builder made for chess coaches, players, and organizations.</p>
            </div>
          </div>
        ) : selectedFilter === 'home' && !isSearchMode ? (
          // Home page layout with categories
          <div className="space-y-8">
            {/* SEO H1 — visible, compact, keyword-rich */}
            <div className="text-center">
              <h1 className="text-2xl md:text-3xl font-bold text-yellow-400">
                Trending Chess Platforms, People & Products
              </h1>
              <p className="text-gray-400 text-sm md:text-base mt-1">
                Browse chess apps, creators, coaches, events, tools, and learning platforms all in one directory.
              </p>
            </div>

            {/* Recent Chess Updates - Featured Section */}
            {recentUpdatesData.length > 0 && (
              <div>
           
                
                {/* Desktop: Complex grid layout with 2x2 small widgets */}
                <div className="hidden md:block">
                  {/* Two separate rows to avoid compression */}
                  <div className="space-y-4">
                    {/* Top Row */}
                    <div className="grid grid-cols-7 gap-4">
                      {/* First BIG widget (2 cols) - ChessWeb.site */}
                      <div className="col-span-2">
                        <FeaturedWidget
                          title="ChessWeb.site"
                          subtitle="Launch Your Chess Website"
                          icon="/images/ChessWebMe.png"
                          link="https://chessweb.site"
                          isNew={false}
                          size="double"
                        />
                      </div>
                      
                      {/* First 2x2 grid of small widgets (2 cols) */}
                      <div className="col-span-2">
                        <div className="grid grid-cols-2 gap-4">
                          {recentUpdatesData.slice(0, 4).map(item => (
                            <FeaturedWidget
                              title={item.title}
                              subtitle={item.subtitle}
                              icon={item.icon}
                              link={item.link}
                              slug={item.slug}
                              isNew={item.isNew}
                              size={item.size ? item.size : "normal"}
                              titled={item.titled}
                              chessTitle={item.chessTitle}
                            />
                          ))}
                        </div>
                      </div>
                      
                      {/* Second BIG widget (3 cols) - "What is Trending Chess?" identity widget */}
                      <div className="col-span-3 relative">
                        <div className="absolute inset-0" style={{ height: 'calc(200% + 1rem)' }}>
                          <FeaturedWidget
                            title="What is Trending Chess?"
                            subtitle="What's trending in chess, driven by AI."
                            icon="/images/WhatIsThis.png"
                            onClick={() => setShowWhatIsThis(true)}
                            isNew={false}
                            size="double"
                          />
                        </div>
                      </div>
                    </div>
                    
                    {/* Bottom Row */}
                    <div className="grid grid-cols-7 gap-4">
                      {/* Bottom 4 small widgets (4 cols) */}
                      <div className="col-span-4">
                        <div className="grid grid-cols-4 gap-4">
                          {recentUpdatesData.slice(4, 8).map(item => (
                            <FeaturedWidget
                              title={item.title}
                              subtitle={item.subtitle}
                              icon={item.icon}
                              link={item.link}
                              slug={item.slug}
                              isNew={item.isNew}
                              size={item.size ? item.size : "normal"}
                              titled={item.titled}
                              chessTitle={item.chessTitle}
                            />
                          ))}
                        </div>
                      </div>
                      
                      {/* Empty space where the big widget extends (3 cols) */}
                      <div className="col-span-3"></div>
                    </div>
                  </div>
                </div>
                
                {/* Mobile: Horizontal layout with scroll */}
                <div className="md:hidden overflow-x-auto scrollbar-hide">
                  <div className="flex gap-4 pb-4" style={{ width: 'max-content' }}>
                    {/* First BIG widget (160px) - ChessWeb.site */}
                    <div className="flex-shrink-0" style={{ width: '160px' }}>
                      <FeaturedWidget
                        title="ChessWeb.site"
                        subtitle="Launch Your Chess Website"
                        icon="/images/ChessWebMe.png"
                        link="https://chessweb.site"
                        isNew={false}
                        size="double"
                      />
                    </div>
                    
                    {/* First 2x2 grid (160px) */}
                    <div className="flex-shrink-0" style={{ width: '160px' }}>
                      <div className="grid grid-cols-2 gap-2 h-full">
                        {recentUpdatesData.slice(4, 8).map(item => (
                            <FeaturedWidget
                              title={item.title}
                              subtitle={item.subtitle}
                              icon={item.icon}
                              link={item.link}
                              slug={item.slug}
                              isNew={item.isNew}
                              size={item.size ? item.size : "normal"}
                              titled={item.titled}
                              chessTitle={item.chessTitle}
                            />
                          ))}
                      </div>
                    </div>

                    {/* Second BIG widget (160px) - "What is Trending Chess?" */}
                    <div className="flex-shrink-0" style={{ width: '160px' }}>
                      <FeaturedWidget
                        title="What is Trending Chess?"
                        subtitle="What's trending in chess, driven by AI."
                        icon="/images/WhatIsThis.png"
                        link="/what-is-this"
                        isNew={false}
                        size="double"
                      />
                    </div>

                    {/* Second 2x2 grid (160px) */}
                    <div className="flex-shrink-0" style={{ width: '160px' }}>
                      <div className="grid grid-cols-2 gap-2 h-full">
                        {recentUpdatesData.slice(0, 4).map(item => (
                            <FeaturedWidget
                              title={item.title}
                              subtitle={item.subtitle}
                              icon={item.icon}
                              link={item.link}
                              slug={item.slug}
                              isNew={item.isNew}
                              size={item.size ? item.size : "normal"}
                              titled={item.titled}
                              chessTitle={item.chessTitle}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Blog Row */}
            {recentBlogs.length > 0 && (
              <div>
                <h2 className="text-xl font-bold text-yellow-400 mb-4 text-left">Latest from the Blog</h2>
                <div className="overflow-x-auto scrollbar-hide">
                  <div className="flex gap-4 pb-4">
                    {recentBlogs.slice(0, 10).map((blog) => (
                      <div
                        key={blog.id}
                        onClick={() => navigate(`/blog/${blog.slug}`)}
                        className="flex-shrink-0 bg-gray-800 rounded-lg overflow-hidden cursor-pointer border border-gray-700 hover:border-gray-600 transition-colors"
                        style={{ width: '250px' }}
                      >
                        {blog.featuredImage && (
                          <div className="aspect-video overflow-hidden">
                            <img
                              src={blog.featuredImage}
                              alt={blog.title}
                              className="w-full h-full object-cover"
                              onError={(e) => { e.target.style.display = 'none'; }}
                            />
                          </div>
                        )}
                        <div className="p-3">
                          <h3 className="text-sm font-bold text-white mb-1 line-clamp-2">{blog.title}</h3>
                          <p className="text-xs text-gray-400 mb-2 line-clamp-2">{blog.excerpt || ''}</p>
                          <span className="text-xs text-gray-500">
                            {blog.createdAt?.toDate ? blog.createdAt.toDate().toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : ''}
                          </span>
                        </div>
                      </div>
                    ))}
                    {/* See All card */}
                    <div
                      onClick={() => navigate('/blogs')}
                      className="flex-shrink-0 bg-gray-800 rounded-lg overflow-hidden cursor-pointer border border-gray-700 hover:border-yellow-400 transition-colors flex items-center justify-center"
                      style={{ width: '250px', minHeight: '200px' }}
                    >
                      <div className="text-center p-4">
                        <span className="text-yellow-400 text-lg font-bold">See All Posts →</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Regular Categories */}
            {getHomePageWidgets().map((category) => (
              <div key={category.name}>
                {/* Category Label with View All link */}
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-xl font-bold text-yellow-400 text-left">
                    {{
                      'people': 'People in Chess',
                      'openings': 'Opening Preparation',
                      'analysis': 'Engine Analysis',
                      'play': 'Play vs. Others',
                      'learn': 'Learning Platforms',
                      'pros': 'Follow Top Chess',
                      'books': 'Explore Chess Books'
                    }[category.name] || category.name}
                  </h2>
                  {(() => {
                    const categoryRouteMap = { people: '/people', openings: '/openings', analysis: '/analysis', play: '/play', learn: '/learn', books: '/books', pros: '/people' };
                    const route = categoryRouteMap[category.name];
                    return route ? (
                      <Link to={route} className="text-gray-400 hover:text-yellow-400 text-sm transition-colors">
                        View All &rarr;
                      </Link>
                    ) : null;
                  })()}
                </div>
                
                {/* Desktop: 8-column grid (7 + see more) */}
                <div className="hidden md:grid grid-cols-7 gap-4">
                  {category.widgets.map((item, index) => {
                    const isEmoji = item.icon && typeof item.icon === 'string' && item.icon.length <= 2 && !item.icon.includes('/');
                    const isReactElement = item.icon && typeof item.icon === 'object' && item.icon.props;
                    const isFontAwesome = item.icon === 'FontAwesomeIcon';
                    return (
                      <Widget
                        key={`${item.title}-${index}`}
                        title={item.title}
                        subtitle={item.subtitle}
                        icon={isFontAwesome ? item.icon : (isEmoji ? item.icon : (isReactElement ? item.icon : <img src={item.icon} alt={item.title} className="w-full h-full object-contain" />))}
                        link={item.internalPageUrl || item.link}
                        isNew={item.isNew}
                        links={item.links}
                        date={item.date}
                        verified={item.verified}
                        slug={item.slug}
                        titled={item.titled}
                        chessTitle={item.chessTitle}
                      />
                    );
                  })}
                  {/* See More Button */}
                  <SeeMoreWidget
                    category={category.name}
                    onClick={() => {
                      const categoryRouteMap = { people: '/people', openings: '/openings', analysis: '/analysis', play: '/play', learn: '/learn', books: '/books', pros: '/people' };
                      const route = categoryRouteMap[category.name];
                      if (route) {
                        navigate(route);
                      } else {
                        setSelectedFilter(category.name);
                        scrollToTop();
                        setSelectedSubFilter(null);
                        setSelectedDeviceFilter(null);
                      }
                    }}
                  />
                </div>

                {/* Mobile: Horizontal scroll container */}
                <div className="md:hidden overflow-x-auto scrollbar-hide">
                  <div className="flex gap-4 pb-4" style={{ width: `${(category.widgets.length + 1) * 140}px` }}>
                    {category.widgets.map((item, index) => {
                      const isEmoji = item.icon && typeof item.icon === 'string' && item.icon.length <= 2 && !item.icon.includes('/');
                      const isReactElement = item.icon && typeof item.icon === 'object' && item.icon.props;
                      const isFontAwesome = item.icon === 'FontAwesomeIcon';
                      return (
                        <div key={`${item.title}-${index}`} className="flex-shrink-0" style={{ width: '130px' }}>
                          <Widget
                            title={item.title}
                            subtitle={item.subtitle}
                            icon={isFontAwesome ? item.icon : (isEmoji ? item.icon : (isReactElement ? item.icon : <img src={item.icon} alt={item.title} className="w-full h-full object-contain" />))}
                            link={item.internalPageUrl || item.link}
                            isNew={item.isNew}
                            links={item.links}
                            date={item.date}
                            verified={item.verified}
                          />
                        </div>
                      );
                    })}
                    {/* See More Button */}
                    <div className="flex-shrink-0" style={{ width: '130px' }}>
                      <SeeMoreWidget
                        category={category.name}
                        onClick={() => {
                          const categoryRouteMap = { people: '/people', openings: '/openings', analysis: '/analysis', play: '/play', learn: '/learn', books: '/books', pros: '/people' };
                          const route = categoryRouteMap[category.name];
                          if (route) {
                            navigate(route);
                          } else {
                            setSelectedFilter(category.name);
                            scrollToTop();
                            setSelectedSubFilter(null);
                            setSelectedDeviceFilter(null);
                              }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (selectedFilter === 'chess' && selectedSubFilter === 'mafia') ? (
          <>
            {/* Title for Mafia tab */}
            <div className="col-span-full mb-8">
              <h2 className="text-2xl font-bold text-yellow-400 text-center">
                The Chess Mafia
              </h2>
            </div>
            <div className="col-span-full text-center text-gray-400 py-20">
              There are no results.
            </div>
          </>
        ) : isSearchMode && (!searchQuery || (getFilteredWidgets().length === 0 && getSearchedBlogs().length === 0)) ? (
          <div className="col-span-full text-center py-20">
            <div className="text-gray-400 mb-6">
              {!searchQuery ? "looking for something?" : "no results found..."}
            </div>
            <button
              onClick={() => navigate('/contact')}
              className=" text-white  px-6 py-3 rounded-lg transition-colors duration-200"
              style={{ fontStyle: 'italic' }}
            >
              contact
            </button>
          </div>
        ) : (
          <>
            {/* Centered gold heading for non-home tabs */}
            {selectedFilter !== 'home' && (
              <div className="col-span-full mb-8">
                <h2 className="text-xl font-bold text-center md:text-left text-gray-100 border border-gray-600 rounded-lg"
                style={{ padding: '5px 5px 5px 15px' }}
                >
                  {selectedFilter === 'all' && 'All Chess Resources'}
                  {selectedFilter === 'events' && 'Chess Events'}
                  {selectedFilter === 'blog' && 'Chess Insights & Stories'}
                  {selectedFilter === 'people' && 'People in Chess'}
                  {selectedFilter === 'books' && 'Explore Chess Books'}
                  {(selectedFilter === 'chess' && selectedSubFilter === 'new') && 'New Releases'}
                  {(selectedFilter === 'openings' || (selectedFilter === 'chess' && selectedSubFilter === 'openings')) && 'Opening Preparation'}
                  {(selectedFilter === 'analysis' || (selectedFilter === 'chess' && selectedSubFilter === 'analysis')) && 'Engine Analysis'}
                  {(selectedFilter === 'play' || (selectedFilter === 'chess' && selectedSubFilter === 'play')) && 'Play vs. Others'}
                  {(selectedFilter === 'social' || (selectedFilter === 'chess' && selectedSubFilter === 'social')) && 'Social Chess Apps'}
                  {(selectedFilter === 'learn' || (selectedFilter === 'chess' && selectedSubFilter === 'learn')) && 'Learning Platforms'}
                  {(selectedFilter === 'mafia' || (selectedFilter === 'chess' && selectedSubFilter === 'mafia')) && 'The Chess Mafia'}
                  {selectedFilter === 'device' && selectedSubFilter === 'web' && 'Web Applications'}
                  {selectedFilter === 'device' && selectedSubFilter === 'ios' && 'ios applications'}
                  {selectedFilter === 'device' && selectedSubFilter === 'android' && 'android applications'}
                  {!['all', 'events', 'people', 'openings', 'analysis', 'play', 'social', 'learn', 'books', 'mafia', 'chess', 'device'].includes(selectedFilter) && selectedFilter.charAt(0).toUpperCase() + selectedFilter.slice(1)}
                </h2>
              </div>
            )}
            {getFilteredWidgets().map((item, index) => {
          // Handle special component widgets
          if (item.type === 'component') {
            if (item.component === 'ConsultingChessBoard') {
              return <ConsultingChessBoard key={`chess-board-${index}`} />;
            }
            if (item.component === 'ChessWebServices') {
              return <ChessWebServices key={`chess-services-${index}`} />;
            }
            return null;
          }
          
          // Handle regular widgets
          const isEmoji = item.icon && typeof item.icon === 'string' && item.icon.length <= 2 && !item.icon.includes('/');
          const isReactElement = item.icon && typeof item.icon === 'object' && item.icon.props;
          const isFontAwesome = item.icon === 'FontAwesomeIcon';

          return (
            <Widget
              key={`${item.title}-${index}`}
              title={item.title}
              subtitle={item.subtitle}
              icon={isFontAwesome ? item.icon : (isEmoji ? item.icon : (isReactElement ? item.icon : <img src={item.icon} alt={item.title} className="w-full h-full object-contain" />))}
              link={item.internalPageUrl || item.link}
              isNew={item.isNew}
              links={item.links}
              date={item.date}
              verified={item.verified}
              slug={item.slug}
            />
          );
            })}
            
            {/* Twitter and Video widgets handled separately as they need special props */}
            <TwitterWidget 
              id="twitter"
              hidden={true}
            />
            <VideoWidget 
              id="videos"
              hidden={true}
            />
            
            <SubWidget miniWidgets={miniWidgets} hidden={true} />
          </>
        )}
      </motion.div>

      {/* Blog search results */}
      {isSearchMode && searchQuery && getSearchedBlogs().length > 0 && (
        <div className="max-w-6xl mx-auto px-4 mt-8">
          <h3 className="text-lg font-bold text-gray-300 mb-4">Blog Posts</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {getSearchedBlogs().map((blog) => (
              <Link
                key={blog.id}
                to={`/blog/${blog.slug || blog.id}`}
                className="block bg-gray-800 border border-gray-700 rounded-lg overflow-hidden hover:border-yellow-400 transition-colors"
              >
                {blog.featuredImage && (
                  <div className="aspect-video overflow-hidden">
                    <img src={blog.featuredImage} alt={blog.title} className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                )}
                <div className="p-4">
                  <h4 className="text-yellow-400 font-semibold mb-1 line-clamp-2">{blog.title}</h4>
                  {blog.metaDescription && (
                    <p className="text-gray-400 text-sm line-clamp-2">{blog.metaDescription}</p>
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Indie Definition */}
      <div style={{ marginTop: '80px' }}>
      <IndieDefinition />
      </div>
    </motion.div>
  );
};

export default HomePage;